import * as React from "react"

import Layout from "../components/layout"
import Seo from "../components/seo"
import { Link } from 'gatsby'

const NotFoundPage = () => (
  <Layout>
    <Seo title="PAGE NOT FOUND" />
    <div className="inner p_404">
      <h1>PAGE NOT FOUND</h1>
      <p>お探しのページは見つかりませんでした。<br />お探しのページは移動もしくは<br className="sp"/>削除された可能性があります。<br />ページをお探しの際は、<br className="sp"/>上部のメニューよりお進みください。<br />またこのページをブックマークに登録されていた方は、<br />お手数ですがブックマークの変更をお願いいたします。</p>
      <p><Link to="/">トップページへ</Link></p>
    </div>
  </Layout>
)

export default NotFoundPage
